import React from 'react';

import { flagStyles } from '../settings';

const SvgPW = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4392px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgPW;
